// extracted by mini-css-extract-plugin
export var dividerLine = "_50-0";
export var errorBackground = "_50-1";